import { apiClient } from '@/shared/api';

/**
 * Canonical retail-store directory for the stores tab's join (review fix C1, spec §8.3/A2/Q4):
 * every retail store renders a row — configured or not — and bind never needs a free-text code.
 */
export interface RetailStoreOption {
  code: string;
  name: string;
  active?: boolean | null;
  locationId?: string | null;
  linkedTills?: number;
}

export const listRetailStores = async (): Promise<RetailStoreOption[]> =>
  (await apiClient.get<RetailStoreOption[]>('/api/v1/inventory/availability/retail-stores')).data;
